import React, { FC, useEffect } from 'react';
import classNames from 'classnames';

import { IconCTA } from 'Src/components/buttons/IconCTA';
import { Flex } from 'Src/components/layout/Flex';
import TabButtons from 'Src/components/navigation/TabButtons';
import TabContent from 'Src/components/navigation/TabContent';
import { TabProvider } from 'Src/components/navigation/useTabs';
import AuthRequestTool from 'Src/dev-tools/AuthRequestTool';
import EPXTool from 'Src/dev-tools/EPXTool';
import { LoyaltyCustomerOnboardTool } from 'Src/dev-tools/LoyaltyCustomerOnboardTool';
import { ReceiptPrintTool } from 'Src/dev-tools/ReceiptPrintTool';
import { useLoyalty } from 'Src/feature/loyalty/useLoyalty';
import { useCurrentOperator } from 'Src/feature/operator/useCurrentOperator';
import { routeParamValue } from 'Src/routes/params';

import styles from './DevToolsView.module.scss';

/**
 * react-router will handle separating this view from the bundle via code splitting
 */
const DevToolsView: FC = () => {
  const currentOperator = useCurrentOperator();
  const [isExpanded, setIsExpanded] = React.useState(false);
  const enrollmentStatus = useLoyalty.query.program.getEnrollmentStatus();

  useEffect(() => {
    if (currentOperator.currentOperator && !enrollmentStatus.data?.isEnrolled) {
      enrollmentStatus.refetch();
    }
  }, [currentOperator.currentOperator, enrollmentStatus]);

  const isEnrolled = Boolean(enrollmentStatus?.data?.isEnrolled);

  const tabs = [
    { value: routeParamValue.devAuth, label: 'Auth' },
    { value: routeParamValue.devEPX, label: 'EPX' },
    { value: routeParamValue.devPrint, label: 'Receipt Print' },
  ];

  if (isEnrolled) {
    tabs.push({ value: routeParamValue.devCustomerSignup, label: 'Customer Sign Up' });
  }

  return (
    <div className={classNames(styles['root'], { [styles['root-expanded']]: isExpanded })}>
      <Flex className={styles['content']}>
        <Flex horizontal alignItems="center" justifyContent={isExpanded ? 'flex-end' : 'center'} fullWidth>
          <IconCTA icon={isExpanded ? 'close' : 'construction'} onClick={() => setIsExpanded(!isExpanded)} />
        </Flex>
        <div className={styles['tools']}>
          <TabProvider>
            <TabButtons
              buttons={tabs}
            />
            <div className={styles['tools-content']}>
              <TabContent value={routeParamValue.devAuth}>
                <AuthRequestTool />
              </TabContent>
              {isEnrolled && (
                <TabContent value={routeParamValue.devCustomerSignup}>
                  <LoyaltyCustomerOnboardTool />
                </TabContent>
              )}
              <TabContent value={routeParamValue.devEPX}>
                <EPXTool />
              </TabContent>
              <TabContent value={routeParamValue.devPrint}>
                <ReceiptPrintTool />
              </TabContent>
            </div>
          </TabProvider>
        </div>
      </Flex>
    </div>
  );
};

export default DevToolsView;
